'use client';
import styled from 'styled-components';

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 416px;
`;

export default ColumnWrapper;
